module.exports = __webpack_public_path__ + "static/img/Ian.Robson.e4ebeab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ian.Robson.jpg
// module id = 1Cct
// module chunks = 0